import AxiosBase from 'axios';

const Axios = AxiosBase.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
});

export default Axios;
